import {
  FETCH_SRP_DATA,
  IUpdate_Filter,
  IUpdate_Srp_Config,
  UPDATE_FILTER,
  UPDATE_SRP_CONFIG,
  IFetch_Srp_Data,
  IToggle_Loading,
  TOGGLE_LOADING,
  RESET_FILTER,
  RESET_SRP_DATA,
  IReset_Filter,
  IReset_Srp_Data,
  IUpdate_Srp_Offer_Data,
  UPDATE_SRP_OFFER_DATA,
} from './types';

export function updateSrpConfigAction(
  actionData: IUpdate_Srp_Config['actionData'],
): IUpdate_Srp_Config {
  return {
    type: UPDATE_SRP_CONFIG,
    actionData,
  };
}

export function fetchSrpDataAction(
  actionData: IFetch_Srp_Data['actionData'],
  loadingMore?: boolean,
): IFetch_Srp_Data {
  return {
    type: FETCH_SRP_DATA,
    actionData,
    loadingMore,
  };
}

export function updateFilterAction(actionData: IUpdate_Filter['actionData']): IUpdate_Filter {
  return {
    type: UPDATE_FILTER,
    actionData,
  };
}

export function updateSrpOfferDataAction(
  actionData: IUpdate_Srp_Offer_Data['actionData'],
): IUpdate_Srp_Offer_Data {
  return {
    type: UPDATE_SRP_OFFER_DATA,
    actionData,
  };
}

export function toggleIsLoadingAction(actionData: IToggle_Loading['actionData']): IToggle_Loading {
  return {
    type: TOGGLE_LOADING,
    actionData,
  };
}

export function resetFilterAction(): IReset_Filter {
  return {
    type: RESET_FILTER,
  };
}

export function resetSrpDataAction(): IReset_Srp_Data {
  return {
    type: RESET_SRP_DATA,
  };
}
